import styled, { css } from "styled-components";

import {
  SelectButton,
  SelectButtonDivider,
  SelectButtonDividerWrapper,
  SelectContentWrapper,
} from "@FillInTableContainer/shared/styles/rowSelectButton.style";

export const GroupShellOutsideWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-left: 0;
`;

export const GroupShellWrapper = styled.div<{
  isFocused?: boolean;
  isClearGroupShell?: boolean;
  isDeleteGroupShell?: boolean;
  isAlertGroupShell?: boolean;
  isTableScroll?: boolean;
  isDragging?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 0px solid transparent;

  ${({ isFocused }) => isFocused && css``}

  ${({ isTableScroll }) =>
    isTableScroll &&
    css`
      min-width: max-content;
    `}

  ${({ isClearGroupShell }) => isClearGroupShell && css``};

  ${({ isDeleteGroupShell }) => isDeleteGroupShell && css``};

  ${({ isAlertGroupShell }) => isAlertGroupShell && css``};

  ${({ isDragging }) =>
    isDragging &&
    css`
      border: none;
      box-shadow: none;
      padding: 0;
    `}
`;

export const GroupShell = styled.div<{
  $isFocused?: boolean;
  $isDeleted?: boolean;
}>`
  display: flex;
  align-self: stretch;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  border: 2px solid transparent;

  ${({ $isFocused }) =>
    $isFocused &&
    css`
      border: 2px solid #017abc;
    `};

  ${({ $isDeleted }) =>
    $isDeleted &&
    css`
      border: 2px solid #fdbba5;
    `};
`;

export const DeleteTableButtonWrapper = styled.div<{ $isDragging?: boolean }>`
  position: absolute;
  left: 0px;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  transform: translate(0, -50%);
  z-index: 10;
`;
export const DeleteTableButton = styled.button`
  position: sticky;
  left: 1rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 1.6rem;
  height: 1.6rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.color.neural.white};
  border-radius: 0.4rem;
  background: var(--Color-Common-Bg-Warning, #e53e06);
  white-space: nowrap;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16), 0 0 1px 0 rgba(0, 0, 0, 0.12);

  & > svg {
    width: 100%;
    height: 100%;
  }

  &:hover {
    width: 2rem;
    height: 2rem;
    padding: var(--Spacing-0, 0) 0;
    border-radius: 0.4rem;
    background: var(--Color-Common-Bg-Interactive-Destructive-Hovereb, #b83205);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 0 4px 0 rgba(0, 0, 0, 0.12);

    svg path {
      fill: #feddd2;
    }
  }
  &:active {
    width: 2rem;
    height: 2rem;
    padding: var(--Spacing-0, 0) 0;
    border-radius: 0.4rem;
    background: var(
      --Color-Common-Bg-Interactive-Destructive-Pressedb,
      #8b2504
    );
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);

    svg path {
      fill: #feddd2;
    }
  }
`;

export const DragButton = styled.div`
  width: 1.6rem;
  height: 2.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 2.8em;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  & .rights-scope-sub-group-shell-drag-button {
    width: 1.2rem;
    height: 2rem;
    background-color: blue;
    display: flex;
    padding: var(--Spacing-0, 0) 0;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    background: var(--Color-Common-Bg-Tertiary, #cbd0d8);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16), 0 0 1px 0 rgba(0, 0, 0, 0.12);
    border: none;
    outline: none;

    &:hover {
      width: 1.6rem;
      height: 2.8rem;
      border-radius: 0.6rem;
      border: none;
      background: var(--Color-Common-Bg-Interactive-Selected-Hovered, #d1efff);
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 0 4px 0 rgba(0, 0, 0, 0.12);

      & > svg {
        fill: #017abc;
      }
    }
    &:active {
      width: 1.6rem;
      height: 2.8rem;
      border-radius: 0.6rem;
      border: none;
      background: #a4dfff;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);

      & > svg {
        fill: #015d8e;
      }
    }
  }
  & .rights-scope-sub-group-shell-drag-button svg {
    width: 100%;
    height: 100%;
  }
`;

export const SelectWrapper = styled(SelectContentWrapper)<{
  isPossibleSelected: boolean;
}>`
  padding: 0;
  width: 100%;
`;

export const GroupShellSelectButton = styled(SelectButton)``;

export const GroupShellSelectButtonDivider = styled(SelectButtonDivider)``;

export const GroupShellSelectButtonDividerWrapper = styled(
  SelectButtonDividerWrapper,
)`
  width: 3.6rem;
`;
